import React from 'react';
import styled from '@emotion/styled';
import { CardGrid } from '@naf/card-grid';
import { AdvancedImage, lazyload } from '@cloudinary/react';
import { GridCol } from '@naf-simba/building-blocks-grid';
import { ArticleReference } from '@appTypes/articleReferenceType';
import { useDocumentUrlWithNode } from '@hooks/Documents/useDocumentUrl';
import { StyledLink } from '@components/styled-link/StyledLink';
import { useCloudinary } from '@hooks/Cloudinary/useCloudinary';

interface Props {
  article: ArticleReference;
}

export const NewsCard = ({ article }: Props) => {
  const { getResponsiveImage } = useCloudinary();
  const cldImage = getResponsiveImage(article.image?.public_id || article.image?.publicId, {
    width: 512,
    quality: 'auto:low',
    focusMethod: article.image?.focus,
  });
  const itemUrl = useDocumentUrlWithNode(article) || '';

  return (
    <StyledCol s="12" m="6" l="6" xl="4">
      <StyledLink to={itemUrl} $hasCardGrid>
        <CardGrid
          headerTag="h2"
          title={article.name}
          memberLabel={
            article?.paywallDetails
              ? {
                  labelText: article?.paywallDetails?.labelText || 'For medlemmer',
                  isEligible: article.paywallDetails?.isAccessibleForUser,
                  inverted: true,
                }
              : undefined
          }
          advancedImage={
            cldImage && (
              <AdvancedImage
                alt={article.image?.altText || ''}
                cldImg={cldImage}
                plugins={[lazyload({ rootMargin: '10px 20px 10px 30px', threshold: 0.25 })]}
              />
            )
          }
          img={{
            src: article.image?.srcSet?.jpgLarge || '',
            alt: article.image?.altText || '',
          }}
        >
          {article?.ingress}
        </CardGrid>
      </StyledLink>
    </StyledCol>
  );
};

const StyledCol = styled(GridCol)`
  display: flex;
`;
